import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { IExam, IFileDownload, IExamQuestions } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { Subject } from 'rxjs';
import { Router, UrlSerializer } from '@angular/router';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { TableMode } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
@Component({
  selector: 'app-exam-saq-answers-update',
  templateUrl: './exam-saq-answers-update.component.html',
  styleUrls: ['./exam-saq-answers-update.component.scss']
})
export class ExamSaqAnswersUpdateComponent implements OnInit {
  selectedQuestions: IExamQuestions[] = [];

  exam: IExam = examDefault;
  questionList: IExamQuestions[] = null;
  modelError = '';
  selectedQuestion: IExamQuestions = null;
  constructor(private examService: ExamService, private router: Router, private snackBar: SnackbarService,
    private serializer: UrlSerializer,) { }
  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [],
      sortParam: {
        fieldName: "",
        orderDirection: 0
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'Question Number',
      fieldName: 'questionNumber',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Question Type',
      fieldName: 'questionType',
      fieldDataType: FieldDataType.enum,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Language',
      fieldName: 'language',
      fieldDataType: FieldDataType.enum,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Question Html',
      fieldName: 'questionHtml',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Category',
      fieldName: 'category',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Marks',
      fieldName: 'marks',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Disabled',
      fieldName: 'disabled',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,

    },
  ];

  async ngOnInit() {
    GridUtil.setClearGridSelection();
    this.examService.reloadGrid.subscribe((value) => {
      this.refreshData(this.data.tableParams);
    });
    this.examService.setSelectedQuestion([]);
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];
      await this.refreshData(this.data.tableParams);
    }
  }

  updateGridParams(res: any) {
    this.data.tableRows = [];
    const tableParams = { ...this.data.tableParams, pageInfo: res[0].pageInfo };
    this.data.tableParams = tableParams;
    this.data.tableRows.push(...res.slice(1, res.length));
  }

  async refreshData(tableParams) {
    tableParams.ExaminationID = this.exam.id;
    const res = await this.examService.getExamQuestions(tableParams) as any[];
    this.updateGridParams(res);
  }

  emitQuestionData(quesIds: any[]) {
    const questionList: any[] = [];
    quesIds.forEach(x => questionList.push(this.data.tableRows[x]));
    this.selectedQuestions = questionList;
    this.selectedQuestion = this.selectedQuestions[0];
    this.examService.setSelectedQuestion([...this.selectedQuestions]);
  }

  editQuestion() {
    let qID = this.examService.selectedQuestionsIds[0];
    this.router.navigate([`questions/${qID}`]);
  }

  getQuestionType(_type) {
    switch (_type) {
      case 'OptionsOnly':
        return 'Multiple-Choice';
      case 'OptionsAndEssay':
        return 'Multiple-Choice and Essay';
      default:
        return 'NotSet';
    }
  }

  addQuestion() {
    this.selectedQuestion = {
      examinationQuestionID: 0,
      examinationID: 0,
      questionNumber: 0,
      questionType: '',
      questionHtml: '',
      category: '',
      marks: 0,
      disabled: false,
      penaltyMarks: 0,
      options: [],
      saqPossibleAnsers: '',
      language: '',
      maxWordCount: 0,
      languageEnum: '',
      compulsory: false,
      questionSource: '',
      essaySubQuestions: []
    };
  }

  deleteQuestion() {
    let data = { questionIds: this.examService.selectedQuestionsIds };
    const reportTree = this.router.createUrlTree([], { queryParams: data });
    let params = this.serializer.serialize(reportTree).split('?', 2)[1];

    this.examService.deleteQuestion(params).then(async s => {
      await this.refreshData(this.data.tableParams);
      this.snackBar.success('Question deleted successfully!!');
    });
  }

  async exportQuestionsClicked() {
    const res = await this.examService.exportQuest(this.exam.id, "Format1", "").then((res: IFileDownload) => {

      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', '' + 'data:application/octet-stream;base64,' + res.file);
      link.setAttribute('download', res.fileName + '.' + res.extension);
      document.body.appendChild(link);
      link.click();
      this.snackBar.success("Questions Exported successfully");
      link.remove();
    });
  }
  // changeStatus(id) {
  //   this.examService.changeQuestionStatus(id).then(s => {
  //     this.snackBar.success('SUCCESSFULL!!');
  //     this.questionList.forEach(q => {
  //       if (q.examinationQuestionID == id) {
  //         q.disabled = !q.disabled;
  //       }
  //       return q;
  //     })
  //   });
  // }
}
